"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.upload_file = void 0;
const api_1 = require("../api");
function upload_file(request, loader = true) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append("file", request.file);
        formData.append("name", request.file_name);
        formData.append("description", request.description);
        formData.append("type", request.type);
        formData.append("category", request.category);
        return yield new api_1.API().apiPost({
            baseUrl: (_a = process.env.UPLOAD_MEDIA_URL) !== null && _a !== void 0 ? _a : "",
            endpoint: "upload/upload",
            content: formData,
            customHeaders: {
                "Content-Type": "multipart/form-data",
            },
            authorization: process.env.UPLOAD_MEDIA_TOKEN,
            loader,
        });
    });
}
exports.upload_file = upload_file;
